import { toAbsoluteUrl, KTSVG } from '../../../helpers'

const HeaderMobile = () => {
	return (
		<div
			id="kt_header"
			className="header align-items-stretch bg-kumopack-base-white mobile-custom-header">
			<div className="d-flex flex-row justify-content-between px-5 py-5">
				{/* begin:: Logo */}
				<div>
					<img
						src={toAbsoluteUrl('/media/kumopack-logo/kumopack-logo-1.png')}
						alt="Kumopack Logo 2"
						width={200}
					/>
				</div>
				{/* end:: Logo */}

				{/* begin::Aside toggle */}
				<div className="d-flex align-items-center d-lg-none ms-n3 me-1" title="Show aside menu">
					<div
						className="btn btn-icon btn-active-color-primary w-30px h-30px"
						id="kt_aside_mobile_toggle">
						<KTSVG path="/media/icons/duotune/abstract/abs015.svg" className="svg-icon-1" />
					</div>
				</div>
				{/* end::Aside toggle */}
			</div>
		</div>
	)
}

export default HeaderMobile
